export const BITECOIN_AMOUNT_WARNING_PERCENT = 0.9;
